import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  province: 'Buenos Aires',
  product: 'Protocolo de Soberanía Total'
}, {
  name: 'Carolina S.',
  province: 'Córdoba',
  product: 'El Código de la Hija Libre'
}, {
  name: 'Valentina R.',
  province: 'Santa Fe',
  product: 'Protocolo de Soberanía Total'
}, {
  name: 'Luciana M.',
  province: 'Mendoza',
  product: 'El Código de la Hija Libre'
}, {
  name: 'Florencia G.',
  province: 'Tucumán',
  product: 'Protocolo de Soberanía Total'
}, {
  name: 'Romina P.',
  province: 'Entre Ríos',
  product: 'El Código de la Hija Libre'
}, {
  name: 'Agustina D.',
  province: 'Salta',
  product: 'Protocolo de Soberanía Total'
}, {
  name: 'Camila T.',
  province: 'Neuquén',
  product: 'El Código de la Hija Libre'
}, {
  name: 'Daniela F.',
  province: 'Misiones',
  product: 'Protocolo de Soberanía Total'
}, {
  name: 'Sofía B.',
  province: 'Chaco',
  product: 'El Código de la Hija Libre'
}, {
  name: 'Paula V.',
  province: 'San Juan',
  product: 'Protocolo de Soberanía Total'
}, {
  name: 'Andrea K.',
  province: 'Río Negro',
  product: 'El Código de la Hija Libre'
}, {
  name: 'Julieta H.',
  province: 'Corrientes',
  product: 'Protocolo de Soberanía Total'
}, {
  name: 'Natalia C.',
  province: 'Jujuy',
  product: 'El Código de la Hija Libre'
}, {
  name: 'Gabriela R.',
  province: 'La Pampa',
  product: 'Protocolo de Soberanía Total'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 3;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // Show next one after 12-20 seconds
      const nextDelay = Math.floor(Math.random() * 8000) + 12000;
      const showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, nextDelay);
      return () => clearTimeout(showTimer);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-28 md:bottom-4 left-4 z-[50] max-w-[250px] sm:max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-280">
      <div className="bg-[#2D1B1B] border border-[#C9A96E]/20 rounded-xl p-3.5 shadow-[0_8px_30px_rgba(0,0,0,0.5)] backdrop-blur-sm" data-id="element-281">
        <div className="flex items-start gap-3" data-id="element-282">
          <div className="w-9 h-9 rounded-full bg-[#C9A96E]/20 border border-[#C9A96E]/30 flex items-center justify-center flex-shrink-0" data-id="element-283">
            <span className="text-sm" data-id="element-284">🌹</span>
          </div>
          <div className="min-w-0" data-id="element-285">
            <p className="text-[#F5ECD7] text-sm font-semibold leading-tight" data-id="element-286">
              {purchase.name}
              <span className="text-[#FAF3E8] font-normal" data-id="element-287"> de </span>
              <span className="text-[#C9A96E]" data-id="element-288">{purchase.province}</span>
            </p>
            <p className="text-[#FAF3E8] text-xs mt-0.5" data-id="element-289">
              adquirió{' '}
              <span className="text-[#F5ECD7] font-medium" data-id="element-290">
                {purchase.product}
              </span>
            </p>
            <p className="text-[#D4A5A5] text-[10px] mt-1" data-id="element-291">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}